import { UserDTO, UserNotification } from '@/lib/types/user'
import api from './axios'

const baseUrl = '/rest/v1/users'

export async function getLoggedUser(): Promise<UserDTO> {
  const res = await api.get(baseUrl + '/me')
  return res.data
}

export async function getUsers(params?: PagedRequestParams): Promise<PagedResult<UserDTO>> {
  const body = params ? {
    params: {
      offset: params.offset,
      limit: params.limit,
      sortField: params.sortField,
      sortOrder: params.sortOrder,
      ...params.filters
    }
  } : {}
  const res = await api.get(baseUrl, body)
  return res.data
}

export async function getUsersByIds(ids: string[]): Promise<PagedResult<UserDTO>> {
  const res = await api.post(`${baseUrl}/find`, ids)
  return res.data
}

export async function updateUser(data: UserDTO): Promise<ErrorMessage | UserDTO> {
  const payload = {
    role_id: data.roleId,
    type: data.type,
    enabled: data.enabled
  }
  const res = await api.put(`${baseUrl}/${data.id}`, payload)
  return res.data
}

export async function getUserNotifications(id: string): Promise<Record<string, UserNotification>> {
  const res = await api.get<Record<string, UserNotification>>(`${baseUrl}/notifications/${id}`)
  return res.data
}